<template>
  <div :class="['card-profile-sales-graph', { full: page }]">
    <card-profile-sales-graph-header
      :auction-only="card.auctionOnly"
      :is-public="isPublic"
      :card-id="cardId"
      :card="card"
    />

    <div class="container">
      <div>
        <sales-stats :timeline-data="timelineData" :page="page" />
      </div>

      <graph
        :label="card.label"
        :labels="labels"
        :datasets="datasets"
        :zoom.sync="localZoom"
        :scale.sync="localScale"
        :is-public="isPublic"
        @saleClicked="handleSaleClicked"
      />
    </div>
  </div>
</template>

<script>
import { getSalesGraphData } from '../utils/graphs.util';

import CardProfileSalesGraphHeader from './CardProfileSalesGraphHeader';
import SalesStats from './SalesStats';
import Graph from './Graph';

export default {
  components: {
    CardProfileSalesGraphHeader,
    SalesStats,
    Graph,
  },

  props: {
    card: Object,
    cardId: String,
    zoom: [Number, Object],
    scale: String,
    isPublic: Boolean,
    page: Boolean,
  },

  data() {
    return {
      timelineData: {},
      labels: [],
      datasets: [],
      localZoom: this.zoom,
      localScale: this.scale,
    };
  },

  created() {
    this.setupData();
  },

  watch: {
    card: {
      handler() {
        this.setupData();
      },
      deep: true,
    },

    zoom(value) {
      this.localZoom = value;
      this.setupData();
    },

    scale(value) {
      this.localScale = value;
      this.$emit('update:scale', value);
    },

    localZoom(value) {
      this.$emit('update:zoom', value);
    },

    localScale(value) {
      this.$emit('update:scale', value);
    },
  },

  methods: {
    setupData() {
      const response = getSalesGraphData(this.card, this.localZoom);

      this.labels = response.labels;
      this.datasets = response.datasets;
      this.timelineData = response.timelineData;
    },

    handleSaleClicked(sale) {
      if (!this.isPublic) {
        this.$emit('saleClicked', sale);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/variables.scss';

.card-profile-sales-graph {
  padding-top: $gp;
  border-top: solid 1px var(--theme-border);
  margin-bottom: $gp * 2;

  .container {
    display: flex;
    flex-direction: column-reverse;

    .graph {
      margin-bottom: $gp;
    }
  }

  &.full {
    @media($medium-up) {
      .container {
        display: grid;
        grid-gap: $gp;
        grid-template-columns: minmax(220px, 1fr) 3fr;
      }

      .graph {
        margin-left: $gp;
      }
    }
  }
}
</style>
